import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit-medical-documents.diagnoses': {
         interactiveTable: {
            autosuggest: {
               label: 'Rozpoznanie',
               placeholder: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
            },
            cells: {
               bodySide: {
                  left: {
                     label: 'lewa',
                  },
                  right: {
                     label: 'prawa',
                  },
               },
            },
            headers: {
               bodySide: 'Strona ciała (jeśli dotyczy)',
               icd10: 'ICD-10',
               main: 'Główne',
               name: 'Nazwa choroby',
            },
            validation: {
               noMainDiagnosis: 'Wybierz rozpoznanie główne',
               tooManyMainDiagnoses: 'Wybierz maks. 1 rozpoznanie główne',
            },
         },
      },
   },
};

const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.visit-medical-documents.diagnoses'
);

export const interactiveTableKeys = translationKeys.interactiveTable;
